import type { ReactElement } from 'react';

export interface StepperProps {
  count: number;
  activeIndex: number;
}

export function Stepper({ count, activeIndex }: StepperProps): ReactElement | null {
  if (count <= 1) return null;
  return (
    <div
      className="flex items-center justify-center gap-1.5"
      role="progressbar"
      aria-valuemin={1}
      aria-valuemax={count}
      aria-valuenow={Math.min(count, Math.max(1, activeIndex + 1))}
      aria-label={`Step ${activeIndex + 1} of ${count}`}
      data-testid="cooking-stepper"
      data-active-index={activeIndex}
    >
      {Array.from({ length: count }, (_, i) => (
        <span
          key={i}
          aria-hidden="true"
          data-step-index={i}
          data-active={i === activeIndex ? 'true' : 'false'}
          className="h-2 w-2 rounded-full"
          style={{
            background:
              i === activeIndex
                ? 'var(--accent)'
                : 'color-mix(in srgb, var(--border) 60%, transparent)',
          }}
        />
      ))}
    </div>
  );
}
